<section global-hero [heroData]="heroData"></section>
<section jump-to [jumpToData]="jumpToData" [activeSection]="jumpToData[0].buttonFragment"></section>
<section section1></section>
<section quiz></section>
<section cta-bottom class="know-your-risk pb-0" [data]="ctaBottomData"></section>
<section cta-bottom class="know-your-risk" [data]="ctaBottomData2"></section>
<review-bar dateText="in June 2026"></review-bar>
